<MenuComponent></MenuComponent>
<BusinessGrowthComponent class="container-component"></BusinessGrowthComponent>
<SuccessStoriesComponent class="container-component"></SuccessStoriesComponent>
<YompMobileComponent class="container-component"></YompMobileComponent>
<YompPremiumComponent class="container-component"></YompPremiumComponent>
<UsComponent class="container-component"></UsComponent>
<YompServicesComponent class="container-component"></YompServicesComponent>
<FrequentQuestionsComponent class="container-component"></FrequentQuestionsComponent>